import { Handler, registerHandlers } from 'pagedjs';

class RepeatingTableHeader extends Handler {
  constructor(chunker, polisher, caller) {
    super(chunker, polisher, caller);
  }

  afterPageLayout(pageElement) {
    const splitTables = pageElement.querySelectorAll('.table[data-split-from]');

    splitTables.forEach((tableFragment) => {
      const parentSection = tableFragment.closest('section');
      const rootId = parentSection?.getAttribute('data-page-root-id');
      const sectionsWithRepeatableHeaders = ['financial-plan', 'implementation-plan', 'performance-monitoring-framework'];

      if (!sectionsWithRepeatableHeaders.includes(rootId)) return;

      if (tableFragment.querySelector('.cloned-thead')) return;

      const ref = tableFragment.getAttribute('data-ref');
      const sourceTable = document.querySelector(`.table[data-ref="${ref}"]:not([data-split-from])`);

      if (sourceTable) {
        if (rootId === 'financial-plan') {
          const sectionLabel = parentSection?.getAttribute('data-label');
          if (sectionLabel) {
            const labelDiv = document.createElement('div');
            labelDiv.className = 'continued-label';
            labelDiv.innerHTML = `${sectionLabel} Cont.`;
            tableFragment.parentNode.insertBefore(labelDiv, tableFragment);
          }
        }

        const thead = sourceTable.querySelector('.thead');
        if (thead) {
          const clonedHeader = thead.cloneNode(true);
          clonedHeader.classList.add('cloned-thead');
          tableFragment.insertBefore(clonedHeader, tableFragment.firstChild);
        }
      }
    });
  }
}

registerHandlers(RepeatingTableHeader);
